module.exports = __webpack_public_path__ + "static/media/appachef.4d9f2f1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/brand-logos/appachef.jpg
// module id = 1062
// module chunks = 0